import React from "react";
import { Route, Switch } from "react-router-dom";

// pages
import Dashboard from "../Pages/RichiestaAbbonamento/RichiestaAbbonamento";

export default function Routes(props) {
  return (
    <Switch>
      <Route exact path="/" component={Dashboard} />
      <Route exact path="/dashboard" component={Dashboard} />
    </Switch>
  );
}
